import { trimExcerptModified } from './helpers';

const endpoint = '/wp-json/wp/v2/dental-advice';
const perPage = 6;

const fetchPosts = (
	initialLoad = true,
	searchTerm,
	page = 0,
	rootNode,
	gridNode,
	templateNode,
	noResultTemplateNode,
	paginationNode
) => {
	rootNode.classList.add('is-loading');
	if (initialLoad === false) smoothScroll();

	fetch(
		`${endpoint}?search=${searchTerm}${page > 0 ? `&page=${page}` : ''}&per_page=${perPage}`
	)
		.then(async (response) => {
			const data = await response.json();
			const noResultsClone = noResultTemplateNode.content.cloneNode(true);

			if (data && data.length > 0) {
				const totalPages = response.headers.get('x-wp-totalpages');

				rootNode.innerHTML = '';
				rootNode.appendChild(gridNode);
				rootNode.appendChild(paginationNode);
				gridNode.innerHTML = '';

				data.forEach((item) => {
					const post = constructPostFromTemplate(templateNode, item);
					gridNode.appendChild(post);
				});

				constructPagination(
					totalPages,
					page === 0 ? page + 1 : page,
					searchTerm,
					rootNode,
					gridNode,
					templateNode,
					noResultTemplateNode,
					paginationNode
				);
			} else {
				const searchTermNode = noResultsClone.querySelector('p > span');
				searchTermNode.innerHTML = `${searchTerm}`;

				rootNode.innerHTML = '';
				rootNode.appendChild(noResultsClone);
			}
		})
		.catch((error) => {
			console.log(error);
			const noResultsClone = noResultTemplateNode.content.cloneNode(true);
			const searchTermNode = noResultsClone.querySelector('p > span');

			searchTermNode.innerHTML = `${searchTerm}`;

			rootNode.innerHTML = '';
			rootNode.appendChild(noResultsClone);
		})
		.finally(() => {
			rootNode.classList.remove('is-loading');
		});
};

const constructPostFromTemplate = (template, data) => {
	const cloneNode = template.content.cloneNode(true);
	const linkNode = cloneNode.querySelector('.wp-listing__link');
	const headingNode = cloneNode.querySelector('.wp-listing__heading > h3');
	const contentNode = cloneNode.querySelector('.wp-listing__content > div');

	const { link, title, excerpt, content } = data;

	const extractedContent = new DOMParser()
		.parseFromString(content.rendered, 'text/html')
		?.querySelector('.wp-block-sed-content .wp-part-content')?.innerHTML;

	linkNode.setAttribute('href', link);
	headingNode.innerHTML = title.rendered;
	contentNode.innerHTML = excerpt.rendered
		? `<p>${excerpt.rendered}</p>`
		: extractedContent
			? trimExcerptModified(extractedContent)
			: '';

	contentNode.innerHTML == ''
		? (contentNode.style.display = 'none')
		: (contentNode.style.display = 'block');

	return cloneNode;
};

const constructPagination = (
	totalPages = null,
	currentPage,
	searchTerm,
	rootNode,
	gridNode,
	templateNode,
	noResultTemplateNode,
	paginationNode
) => {
	paginationNode.innerHTML = '';

	if (!totalPages || !paginationNode || totalPages <= 1) return;

	for (let i = 0; i < totalPages; i++) {
		const page = i + 1;

		const li = document.createElement('li');
		const button = document.createElement('button');
		button.textContent = page;
		if (page === currentPage) button.classList.add('is-current-page');

		li.appendChild(button);

		button.addEventListener('click', () => {
			fetchPosts(
				false,
				searchTerm,
				page,
				rootNode,
				gridNode,
				templateNode,
				noResultTemplateNode,
				paginationNode
			);
		});

		paginationNode.appendChild(li);
	}
};

const smoothScroll = () => {
	const mql = window.matchMedia('(max-width: 48.0625em)');
	const node = mql.matches
		? document.getElementById('results')
		: document.getElementById('search');

	const yOffset = -150;
	const y = node.getBoundingClientRect().top + window.scrollY + yOffset;
	window.scrollTo({ top: y, behavior: 'smooth' });
};

const init = () => {
	const searchNode = document.querySelector('.wp-part-search');
	const listingNode = document.querySelector('.wp-listing');

	if (searchNode && listingNode) {
		const formNode = search.querySelector('form');
		const inputNode = formNode?.querySelector('input');
		const resultNode = listingNode.querySelector('.wp-listing__results');
		const gridNode = listingNode.querySelector('.wp-listing__grid');
		const postTemplateNode = listingNode.querySelector(
			'template.wp-listng__template'
		);
		const noResultTemplateNode = listingNode.querySelector(
			'template.wp-lisitng__no-results'
		);
		const paginationNode = listingNode.querySelector(
			'.wp-listing__pagination'
		);

		fetchPosts(
			true,
			'',
			0,
			resultNode,
			gridNode,
			postTemplateNode,
			noResultTemplateNode,
			paginationNode
		);

		formNode.addEventListener('submit', (e) => {
			e.preventDefault();

			const searchTerm = inputNode.value.trim();

			fetchPosts(
				false,
				searchTerm,
				0,
				resultNode,
				gridNode,
				postTemplateNode,
				noResultTemplateNode,
				paginationNode
			);
		});
	}
};

if (document.readyState !== 'loading') {
	init();
} else {
	document.addEventListener('DOMContentLoaded', () => {
		init();
	});
}
